import Vue from "vue";
import Vuex from "vuex";

import actions from '@/store/actions';
import mutations from '@/store/mutations';
import state from '@/store/state';
import Auth from '../Warehouse/Auth';
import Images from '../Warehouse/Images';
import Commons from '../Warehouse/Commons';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {Auth, Images, Commons}
});
